"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateActionItemRequest () {
        return CreateActionItemRequest;
    },
    get CreateAgendaItemRequest () {
        return CreateAgendaItemRequest;
    },
    get CreateMeetingParams () {
        return CreateMeetingParams;
    },
    get CreateMeetingRequest () {
        return CreateMeetingRequest;
    },
    get CreateMeetingWorkspaceRequest () {
        return CreateMeetingWorkspaceRequest;
    },
    get CreateRecurringSeriesParams () {
        return CreateRecurringSeriesParams;
    },
    get CreateRecurringSeriesRequest () {
        return CreateRecurringSeriesRequest;
    },
    get DeleteRecurringSeriesParams () {
        return DeleteRecurringSeriesParams;
    },
    get DeleteRecurringSeriesQuery () {
        return DeleteRecurringSeriesQuery;
    },
    get DismissTranscriptBannerParams () {
        return DismissTranscriptBannerParams;
    },
    get DismissTranscriptBannerRequest () {
        return DismissTranscriptBannerRequest;
    },
    get ExportCompanyMeetingsRequest () {
        return ExportCompanyMeetingsRequest;
    },
    get ExportWorkspaceMeetingsRequest () {
        return ExportWorkspaceMeetingsRequest;
    },
    get GetActionItemsParams () {
        return GetActionItemsParams;
    },
    get GetAgendaItemsParams () {
        return GetAgendaItemsParams;
    },
    get GetCarryOverItemsParams () {
        return GetCarryOverItemsParams;
    },
    get GetCarryOverItemsQueryString () {
        return GetCarryOverItemsQueryString;
    },
    get GetMeetingDetailsParams () {
        return GetMeetingDetailsParams;
    },
    get GetMeetingNotesParams () {
        return GetMeetingNotesParams;
    },
    get GetMeetingNotesQuery () {
        return GetMeetingNotesQuery;
    },
    get GetMeetingTranscriptParams () {
        return GetMeetingTranscriptParams;
    },
    get GetMeetingsParams () {
        return GetMeetingsParams;
    },
    get GetUpcomingMeetingsQueryString () {
        return GetUpcomingMeetingsQueryString;
    },
    get GetWorkspaceParams () {
        return GetWorkspaceParams;
    },
    get GetWorkspaceRecurringSeriesParams () {
        return GetWorkspaceRecurringSeriesParams;
    },
    get GetWorkspaceRecurringSeriesQuery () {
        return GetWorkspaceRecurringSeriesQuery;
    },
    get ReorderActionItemsParams () {
        return ReorderActionItemsParams;
    },
    get ReorderActionItemsRequest () {
        return ReorderActionItemsRequest;
    },
    get ReorderAgendaItemsParams () {
        return ReorderAgendaItemsParams;
    },
    get ReorderAgendaItemsRequest () {
        return ReorderAgendaItemsRequest;
    },
    get RetrieveMeetingTranscriptParams () {
        return RetrieveMeetingTranscriptParams;
    },
    get UpdateActionItemParams () {
        return UpdateActionItemParams;
    },
    get UpdateActionItemRequest () {
        return UpdateActionItemRequest;
    },
    get UpdateAgendaItemParams () {
        return UpdateAgendaItemParams;
    },
    get UpdateAgendaItemRequest () {
        return UpdateAgendaItemRequest;
    },
    get UpdateMeetingNoteParams () {
        return UpdateMeetingNoteParams;
    },
    get UpdateMeetingNoteRequest () {
        return UpdateMeetingNoteRequest;
    },
    get UpdateMeetingParams () {
        return UpdateMeetingParams;
    },
    get UpdateMeetingRequest () {
        return UpdateMeetingRequest;
    },
    get UpdateMeetingTranscriptParams () {
        return UpdateMeetingTranscriptParams;
    },
    get UpdateMeetingTranscriptRequest () {
        return UpdateMeetingTranscriptRequest;
    },
    get UpdateMeetingWorkspaceParams () {
        return UpdateMeetingWorkspaceParams;
    },
    get UpdateMeetingWorkspaceRequest () {
        return UpdateMeetingWorkspaceRequest;
    },
    get UpdateRecurringSeriesParams () {
        return UpdateRecurringSeriesParams;
    },
    get UpdateRecurringSeriesRequest () {
        return UpdateRecurringSeriesRequest;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../meetings-integrations/base");
const _actionitem = require("./action-item");
const _agendaitem = require("./agenda-item");
const _meeting = require("./meeting");
const _notes = require("./notes");
const _recurringseries = require("./recurring-series");
const _transcript = require("./transcript");
const _workspace = require("./workspace");
const GetWorkspaceParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const CreateMeetingWorkspaceRequest = _workspace.WorkspaceModel.pick({
    name: true,
    participants: true
});
const UpdateMeetingWorkspaceRequest = _workspace.WorkspaceModel.pick({
    name: true,
    status: true,
    participants: true
}).partial();
const UpdateMeetingWorkspaceParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const GetMeetingsParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const GetMeetingDetailsParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const GetCarryOverItemsParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const GetCarryOverItemsQueryString = _zod.z.object({
    startDateTime: _utilsisomorphic.transformDate
});
const CreateMeetingRequest = _meeting.MeetingModel.pick({
    name: true,
    description: true,
    startDateTime: true,
    endDateTime: true,
    participants: true
}).extend({
    carryOver: _zod.z.boolean().optional(),
    addToCalendar: _zod.z.boolean().optional(),
    videoConferencingProvider: _base.VideoConferencingProviderEnum.optional()
});
const CreateMeetingParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const UpdateMeetingRequest = _meeting.MeetingModel.pick({
    name: true,
    description: true,
    status: true,
    startDateTime: true,
    endDateTime: true,
    calendarEvent: true
}).extend({
    addToCalendar: _zod.z.boolean().optional(),
    removeFromCalendar: _zod.z.boolean().optional(),
    videoConferencingProvider: _base.VideoConferencingProviderEnum.optional(),
    removeVideoConferencing: _zod.z.boolean().optional()
}).partial();
const UpdateMeetingParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const CreateRecurringSeriesRequest = _meeting.MeetingModel.pick({
    name: true,
    description: true,
    startDateTime: true,
    endDateTime: true,
    participants: true
}).extend({
    recurrence: _recurringseries.RecurrenceModel,
    timezone: _zod.z.string(),
    seriesEndDate: _utilsisomorphic.transformDate.optional(),
    carryOver: _zod.z.boolean().optional(),
    addToCalendar: _zod.z.boolean().optional(),
    videoConferencingProvider: _base.VideoConferencingProviderEnum.optional()
});
const CreateRecurringSeriesParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const GetWorkspaceRecurringSeriesParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const GetWorkspaceRecurringSeriesQuery = _zod.z.object({
    includeDeleted: _zod.z.enum([
        "true",
        "false"
    ]).transform((value)=>value === "true").optional()
});
const UpdateRecurringSeriesRequest = _zod.z.object({
    name: _zod.z.string().optional(),
    description: _zod.z.string().optional(),
    recurrence: _recurringseries.RecurrenceModel.optional(),
    timezone: _zod.z.string().optional(),
    startTimeOfDay: _zod.z.string().optional(),
    durationMinutes: _zod.z.number().int().positive().optional(),
    seriesEndDate: _utilsisomorphic.transformDate.nullable().optional(),
    carryOver: _zod.z.boolean().optional(),
    /**
	 * Earliest date the re-anchored pattern may land on, when a recurrence change
	 * moves the upcoming meeting. Without it the pattern re-anchors from now, which
	 * can pull the upcoming meeting earlier than it already was. Dates in the past
	 * are floored to now.
	 */ scheduleStartDate: _utilsisomorphic.transformDate.optional(),
    /**
	 * true attaches the series to the editor's calendar (retroactive attach when no
	 * native series exists yet); false detaches it — future calendar occurrences are
	 * removed, past ones survive. Omitted leaves the linkage alone.
	 */ addToCalendar: _zod.z.boolean().optional(),
    /**
	 * Provider for the series' video conferencing: every future materialized meeting
	 * is created with a link from this provider, and the current upcoming meeting
	 * gains one when it has none. Omitted leaves the series' provider alone.
	 */ videoConferencingProvider: _base.VideoConferencingProviderEnum.optional(),
    /**
	 * true clears the series' video conferencing provider — future meetings are
	 * created without a link; already-created meetings keep theirs.
	 */ removeVideoConferencing: _zod.z.boolean().optional()
});
const UpdateRecurringSeriesParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId,
    seriesId: _utilsisomorphic.transformObjectId
});
const DeleteRecurringSeriesParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId,
    seriesId: _utilsisomorphic.transformObjectId
});
const DeleteRecurringSeriesQuery = _zod.z.object({
    removeCalendarEvents: _zod.z.enum([
        "true",
        "false"
    ]).transform((v)=>v === "true").optional()
});
const CreateAgendaItemRequest = _agendaitem.AgendaItemModel.pick({
    name: true,
    meetings: true,
    goalId: true
});
const UpdateAgendaItemRequest = _agendaitem.AgendaItemModel.pick({
    name: true,
    meetings: true,
    goalId: true
}).partial();
const UpdateAgendaItemParams = _zod.z.object({
    agendaItemId: _utilsisomorphic.transformObjectId
});
const GetAgendaItemsParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const ReorderAgendaItemsRequest = _zod.z.object({
    agendaItemIds: _zod.z.array(_utilsisomorphic.transformObjectId).min(1)
});
const ReorderAgendaItemsParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const CreateActionItemRequest = _actionitem.ActionItemModel.pick({
    name: true,
    meetings: true,
    participants: true,
    dueDate: true
});
const UpdateActionItemRequest = _actionitem.ActionItemModel.pick({
    name: true,
    meetings: true,
    participants: true,
    dueDate: true
}).partial();
const UpdateActionItemParams = _zod.z.object({
    actionItemId: _utilsisomorphic.transformObjectId
});
const GetActionItemsParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const ReorderActionItemsRequest = _zod.z.object({
    actionItemIds: _zod.z.array(_utilsisomorphic.transformObjectId).min(1)
});
const ReorderActionItemsParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const GetMeetingNotesParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const GetMeetingNotesQuery = _zod.z.object({
    visibility: _zod.z.optional(_models.MeetingNoteVisibilitySchema)
});
const UpdateMeetingNoteRequest = _notes.MeetingNoteModel.pick({
    content: true
});
const UpdateMeetingNoteParams = _zod.z.object({
    noteId: _utilsisomorphic.transformObjectId
});
const GetMeetingTranscriptParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const UpdateMeetingTranscriptRequest = _transcript.MeetingTranscriptModel.pick({
    content: true
});
const UpdateMeetingTranscriptParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const RetrieveMeetingTranscriptParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const DismissTranscriptBannerParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const DismissTranscriptBannerRequest = _zod.z.object({
    bannerKey: _models.TranscriptBannerKeySchema
});
const ExportCompanyMeetingsRequest = _zod.z.object({
    filters: _zod.z.record(_zod.z.string(), _zod.z.any()).optional(),
    sort: _zod.z.object({
        name: _zod.z.string(),
        direction: _zod.z.enum([
            "asc",
            "desc"
        ])
    }).optional(),
    timezone: _zod.z.string()
});
const ExportWorkspaceMeetingsRequest = _zod.z.object({
    filters: _zod.z.record(_zod.z.string(), _zod.z.any()).optional(),
    timezone: _zod.z.string()
});
const GetUpcomingMeetingsQueryString = _zod.z.object({
    startDate: _utilsisomorphic.transformDate,
    endDate: _utilsisomorphic.transformDate
});
